import React, { Component } from 'react';
import TableText from "../../../table/TableText";
import moment from "moment";

export const columnsData = (data, date, print) => {
    const totalIndex = [...new Array(moment(date).daysInMonth()).fill(1).map((x, i) => i + 1).filter(x => moment(date + `-${x}`).format('E') > 5).map(x => x - 1), moment(date).daysInMonth()]

    return [{
        title: moment(date).format('YY-MMM'),
        key: 'day',
        align: "center",
        dataIndex: 'day',
        fixed: print ? false : "left",
        width: 70,
        render: (text, record, index) => {
            return (
                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                    {text}
                </div >
            )
        }
    }, ...data.map((x, i) => {
        return {
            title: <span>{x.name.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.name.replace(/[^\u4E00-\u9FA5]/g, "")}</span>,
            align: "center",
            children: [, {
                title: <span>Coffee Shop (BF)<br/>豪生咖啡厅（早餐）</span>,
                dataIndex: `${x.code || i * i}coffeeBF`,
                key: `${x.code || i * i}coffeeBF`,
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text: text || 0,
                        index,
                        type: "number",
                        name: x.key,
                        totalIndex,
                    };

                    return (
                        <TableText data={{ ...props }} />
                    )
                }
            }, {
                    title: <span>Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）</span>,
                    dataIndex: `${x.code || i * i}coffeeLD`,
                    key: `${x.code || i * i}coffeeLD`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Chinese Restaurant<br/>中餐厅</span>,
                    dataIndex: `${x.code || i * i}Chinese`,
                    key: `${x.code || i * i}Chinese`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Special Restaurant<br/>特色餐厅</span>,
                    dataIndex: `${x.code || i * i}Special`,
                    key: `${x.code || i * i}Special`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Lobby Lounge<br/>大堂酒吧</span>,
                    dataIndex: `${x.code || i * i}Lobby`,
                    key: `${x.code || i * i}Lobby`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Room Service<br/>送餐服务</span>,
                    dataIndex: `${x.code || i * i}Room`,
                    key: `${x.code || i * i}Room`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Banquet<br/>宴会厅</span>,
                    dataIndex: `${x.code || i * i}Banquet`,
                    key: `${x.code || i * i}Banquet`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Mini Bar<br/>迷你吧</span>,
                    dataIndex: `${x.code || i * i}Mini`,
                    key: `${x.code || i * i}Mini`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Executive Club<br/>行政楼层</span>,
                    dataIndex: `${x.code || i * i}Executive`,
                    key: `${x.code || i * i}Executive`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Other Income<br/>其他收入</span>,
                    dataIndex: `${x.code || i * i}Other`,
                    key: `${x.code || i * i}Other`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: <span>Total F&B Revenue<br/>餐饮合计</span>,
                    dataIndex: `${x.code || i * i}Total`,
                    key: `${x.code || i * i}Total`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }]
        }
    })]
}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.4/data.js